import { render, staticRenderFns } from "./GitHubButton.vue?vue&type=template&id=381c2f35&"
import script from "./GitHubButton.vue?vue&type=script&lang=js&"
export * from "./GitHubButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports